import { getApiPath } from '@/shared/api/constants';

const DICTIONARY = 'dictionary';
const EVENT_PROTOCOL = '/eventProtocol';
const BY_TYPE = '/byType';

// DICTIONARY

export const DICTIONARY_API = getApiPath(DICTIONARY);

export const EVENT_PROTOCOL_BY_TYPE = DICTIONARY_API + EVENT_PROTOCOL + BY_TYPE;
